//  ----------      START   IMPORT  BLOCK       ----------
import { useState } from 'react';
import FullCalendar from '@fullcalendar/react'; // FullCalendar core package
import dayGridPlugin from '@fullcalendar/daygrid'; // Month view
import timeGridPlugin from '@fullcalendar/timegrid'; // Week and day view
import interactionPlugin from '@fullcalendar/interaction'; // Enables click and drag events
import esLocale from '@fullcalendar/core/locales/es'; // Spanish locale
import enLocale from '@fullcalendar/core/locales/en-gb'; // English locale
//  Services
import AgendaService from '../../API/Services/AgendaService';

import AddAppointmentModal from './CalendarModals/AddAppointmentModlal';
import CancelAppointmentModal from './CalendarModals/CancelAppointmentModal';

//  Context
import { useSession } from '../../API/Context/SessionContext';
import { useLanguage } from '../../API/Context/LanguageContext';
import { useUserAgenda } from '../../API/Hooks/useUserAgenda';
//  Utils

//  Config
import './Calendar.css'
//  ----------      END   IMPORT  BLOCK       ----------

import AgendaWidget from '../Widgets/Professional/Calendar/AgendaWidget';

const CalendarForm = ({ }) => {
  //  Consume context
  const { user } = useSession();
  const { lan } = useLanguage()
  
  //  Consume agenda hook
   const { 
    agenda, 
    isLoading, 
    error, 
    fetchAgendaForWeek, 
    fetchBusinessHours: fetchBusinessHoursHook, 
    createAppointment: createAppointmentHook,   
    cancelAppointment: cancelAppointmentHook    
  } = useUserAgenda(); 


  //  State Initialization
  //  Add appointment modal.
  const [showAddAppointmentModal, setShowAddAppointmentModal] = useState(false);
  const toggleAddAppointmentModal = () => setShowAddAppointmentModal(!showAddAppointmentModal);
  //  Cancel appointment modal.
  const [showCancelAppointmentModal, setShowCancelAppointmentModal] = useState(false);
  const toggleCancelAppointmentModal = () => setShowCancelAppointmentModal(!showCancelAppointmentModal);
  //  For data retrieval and appointmet creation.
  const [selectedDate, setSelectedDate] = useState(Date.now());
  //  Initialize `currentYear` and `currentWeek` with today's date values
  const { year, week } = {'year': 2025, 'week': 51};
  //  For data retrieval.
  const [lastDateRange, setLastDateRange] = useState({ year, week });
  //  For retrieving data on first execution.
  const [firstExecution, setFirstExecution] = useState(true)
  //  For storing business hours.
  //  API service.
  const agendaService = new AgendaService();

  //  Selected entry.
  const [selectedEntries, setSelectedEntries] = useState({
    //  Default not for use!
    start: new Date("2024-10-29T19:00:00.000Z"),
    end: new Date("2024-10-29T19:30:00.000Z"),
    time_zone: 'UTC',
    location: '',
    username_attendee: '',
    username_medic: '',
    username_organizer: '',
    title: '',
    description: '',
    tags: '',
    status: '',
  });
  //  Transforms data passed form the API into fullCalendars format.
  function transformSchedule(schedule) {
    // Map over each day in the input schedule
    return schedule.flatMap((day, index) => {
      // Determine the day of the week (0 = Sunday to 6 = Saturday)
      const dayOfWeek = index + 1; // FullCalendar uses 1 (Monday) to 7 (Sunday)
  
      // Map each time period in the day's schedule to the desired format
      return day.map(period => ({
        daysOfWeek: [dayOfWeek], // Single day of the week
        startTime: period.start.slice(11, 16), // Extract HH:MM from the "start" time
        endTime: period.end.slice(11, 16) // Extract HH:MM from the "end" time
      }));
    });
  }
  //  BusinessHours
  const [businessHours, setBusinessHours] = useState(
    [
      {
        // First time period (e.g., 7:00 AM to 1:00 PM)
        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
        startTime: '07:00',
        endTime: '13:00'
      },
      {
        // Second time period (e.g., 3:00 PM to 8:00 PM)
        daysOfWeek: [1, 2, 3, 4, 5], // Monday - Friday
        startTime: '15:00',
        endTime: '20:00'
      },
      {
        daysOfWeek: [5, 6], // Friday
        startTime: '09:00', // 9 AM
        endTime: '15:00' // 3 PM
      },
    ]
  )

  // Update a specific field
  const updateEntryField = (field, value) => {
    setSelectedEntries(prevAppointment => ({
      ...prevAppointment,
      [field]: value
    }));
  };

  //  Handler for when dates change.
  const handleDatesSet = (dateInfo) => {
    //  Start of the displayed week
    const startDate = new Date(dateInfo.start);
    const newYear = startDate.getFullYear();
    //setCurrentWeek(getWeekNumber(startDate));
    handleAgendaSearch(newYear, 51);
  };

  const [events, setEvents] = useState([
    {
      title: 'Meeting with Team',
      start: '2024-10-29T10:00:00',
      end: '2024-10-29T11:00:00',
      location: 'Conference Room A',
      description: 'Discussing project updates and next steps',
      organizer: 'John Doe',
      attendee: 'Jane Smith',
      status: 0,
    }
  ]);

  //  Search for bussiness hours.
  const handleBusinessHoursSearch = async () => {
    if (firstExecution){
      try {
        const data = await agendaService.fetchBusinessHours();
        setBusinessHours(transformSchedule(data.weekly_schedule))
        //setBusinessHours
      } catch (error) {
        console.log('No results found.');
        console.error('Error fetching data:', error);
      }
    }
  }

  //  Update agenda with contents from DB.
  const handleAgendaSearch = async (year, week) => {
    //  Execute when oppening & whenever showing different weeks.
    if (year !== lastDateRange.year || week !== lastDateRange.week || firstExecution) {
      try {
        const data = await agendaService.fetchWeek(week, year);
        setEvents(data);
        setLastDateRange({ year, week });
        handleBusinessHoursSearch();
        setFirstExecution(false)
      } catch (error) {
        console.log('No results found.');
        console.error('Error fetching data:', error);
      }
    }
  };

  const handleAddEvent = (newEvent) => {
    // Logic to add the event to FullCalendar
    console.log('New Event:', newEvent);
    handleAppointmentCreate(newEvent)

  };

  //  Create appoitnment
  const handleAppointmentCreate = async (event) => {
    if (true) {
      //  Define appointment details
      const title = event.title;
      const start = event.start;
      const end = event.end;
      
      const tags = 'test'//event.extendedProps.tags
      const time_zone = 'UTC' //event.extendedProps.time_zone
      const description = event.extendedProps.description
      const location = event.extendedProps.location;
      const username_attendee = 'JaimeGQ' //event.extendedProps.attendee
      const username_medic = user.username ?? 'Guest';
      const username_organizer = user.username ?? 'Guest';

      // Call the createAppointment method to make the API request
      ///*
      agendaService.createAppointment(
        start, end, time_zone, location, username_attendee, username_medic, username_organizer, title, description, tags
      )
        .then(response => {
          console.log("Appointment created successfully:", response);
        })
        .catch(error => {
          console.error("Failed to create appointment:", error);
        });
        //*/
    }
        
  };

  const languageSwitch = () => {
    //  Transalte int to language
    switch (lan) {
      case 0:
        return 'es'
      case 1:
        return 'en-gb'
      default:
        return 'es'
    }
  };
  //  Language.
  const [localeCode, setLocaleCode] = useState(languageSwitch(lan));

  //  Function to add a new event.
  const handleDateClick = (info) => {
    //  Update selected date to be used by modal. 
    setSelectedDate(info.dateStr)
    //  Open modal for capturing new appointment.
    toggleAddAppointmentModal()
  };

  //  Function to handle event updates (e.g., when event is dragged/resized)
  const handleEventDrop = (info) => {
    const updatedEvents = events.map(event =>
      event.id === info.event.id
        ? { ...event, start: info.event.startStr, end: info.event.endStr }
        : event
    );
    setEvents(updatedEvents);
  };

  //  Function to delete an event.
  const handleEventClick = (info) => {
    //  Data from the clicked event.
    const { _id, location, status, tags, time_zone, username_attendee, username_medic, username_organizer, description } = info.event.extendedProps;
    /*  Update selectedEntry fields which are passed to modal.  */
    //  Extended attributes.
    updateEntryField('_id', _id)
    updateEntryField('tags', tags)
    updateEntryField('status', status)
    updateEntryField('location', location)
    updateEntryField('time_zone', time_zone)
    updateEntryField('description', description)
    updateEntryField('username_medic', username_medic)
    updateEntryField('username_attendee', username_attendee)
    updateEntryField('username_organizer', username_organizer)
    //  Fields included in entry.
    updateEntryField('title', info.event.title)
    updateEntryField('start', info.event.start)
    updateEntryField('end', info.event.end)
    //  Show modal.
    toggleCancelAppointmentModal()
  };

  const updateEntryStatus = (entryId, newStatus) => {
    setEvents((prevEntries) =>
      prevEntries.map((entry) =>
        entry._id === entryId ? { ...entry, status: newStatus } : entry
      )
    );
  };

  const handleCancelEvent = (canceledEventID) => {
    // Logic to add the event to FullCalendar
    console.log('To cancel:', canceledEventID);
    // Call the createAppointment method to make the API request
    agendaService.deleteAppointment(canceledEventID)
      .then(response => {
        console.log("Appointment canceled successfully:", response);
        updateEntryStatus(canceledEventID, 1)
      })
      .catch(error => {
        console.error("Failed to cancel appointment:", error);
      });
  };


  return (
    <div>
      
      <AgendaWidget/>
    </div>
  );
};

export default CalendarForm;

/*
<FullCalendar
        plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
        initialView="timeGridWeek"
        locale={localeCode}
        locales={[esLocale, enLocale]}
        events={events}
        dateClick={(info) => handleDateClick(info)}
        eventClick={handleEventClick}
        eventDrop={handleEventDrop}
        datesSet={handleDatesSet}
        height="700px"
        editable={true}
        businessHours={businessHours}
        eventClassNames={(eventInfo) => {
          //  Apply a class based on the status.
          switch (eventInfo.event.extendedProps.status) {
            case 0:
              return 'event-confirmed';
            case 1:
              return 'event-pending';
            case 2:
              return 'event-cancelled';
            default:
              return '';
          }
        }}
      />
      <AddAppointmentModal
        show={showAddAppointmentModal}
        onHide={toggleAddAppointmentModal}
        sentDate={selectedDate}
        onSave={handleAddEvent}
      />
      <CancelAppointmentModal
        show={showCancelAppointmentModal}
        onHide={toggleCancelAppointmentModal}
        onSave={handleCancelEvent}
        sentData={selectedEntries}
      />

 */